<template>
  <v-app>
    <v-content>
      <router-view></router-view>
    </v-content>
  </v-app>
</template>

<script>
export default {
  name: "App",
  components: {},

  data: () => ({
    //
  })
};
</script>

<style scoped>
/*To avoide the Auto Uppercase of titles */
* {
  text-transform: none !important;
}
</style>
